import React from "react";
import classes from './linkBlock.module.css';

const OptionBlock = (props) => {
    return (
        <div className={classes.optionBlock} style={props.option.style}>
            <img src={props.option.src} alt="icon" />
            <h3>{props.option.title}</h3>
            <p>{props.option.body}</p>
        </div>
    )
}

export default OptionBlock;